<template>
    <main>
    <div class="h-8 w-full bg-white"></div>
     <div class="p-3">
      <BookingDirection/>
     </div>
    </main>
  </template>
  
  <script>
  import BookingDirection from "@/components/Ondemand/Bookings/BookingDirection.vue";
  
  export default {
    components: {
        BookingDirection,
    },
    data() {
      return {
        doorToDoorShow: true
      }
    },
  };
  </script>
  
  <style></style>
  